import {Box} from '@gwc/core'

export default Box
